<ng-container>
  @if (!ppTags[0] && !ppLimitedTags) {
    <span>
      {{ 'all' | ppTranslate }}
    </span>
  }

  @if (!ppTags[0] && ppLimitedTags) {
    <span>
      {{ 'none' | ppTranslate }}
    </span>
  }

  @if (ppTags[0]) {
    <pp-tag
      [ppText]="ppTags[0]"
      [ppDeletable]="false"
      [ppDisabled]="ppDisabled"
      ppTooltip
      [ppTrimTooltip]="true"
      [ppTitle]="ppTags[0]"
    ></pp-tag>
  }

  @if (ppTags[1]) {
    <pp-tag
      [ppText]="ppTags[1]"
      [ppDeletable]="false"
      [ppDisabled]="ppDisabled"
      ppTooltip
      [ppTrimTooltip]="true"
      [ppTitle]="ppTags[1]"
    ></pp-tag>
  }

  @if (ppTags[2]) {
    <span
      class="tags__showMore"
      ppTooltip
      [ppSanitize]="false"
      [ppTitle]="tagsTooltip"
      >
      + {{ ppTags.length - 2 }} {{ 'more' | ppTranslate }}
    </span>
  }
</ng-container>
